import { OdataQuery } from '../OdataTypes/OdataQuery';
import { QueryParameter } from './QueryParameter';

export class QueryOptions {
  public queryParameters: QueryParameter[];
  public odataQuery: OdataQuery;
  public reportProgress: boolean;
  public useAchor: boolean;
  public fileName: string;
  addQueryParameter(queryParameter: QueryParameter): QueryOptions {
    if (!this.queryParameters) {
      this.queryParameters = [queryParameter];
    } else {
      this.queryParameters.push(queryParameter);
    }

    return this;
  }

  addQueryParameters(queryParameter: QueryParameter[]): QueryOptions {
    if (!this.queryParameters) {
      this.queryParameters = queryParameter.slice(0);
    } else {
      this.queryParameters = this.queryParameters.concat(queryParameter);
    }

    return this;
  }

  setOdataQuery(odataQuery: OdataQuery): QueryOptions {
    this.odataQuery = odataQuery;

    return this;
  }
}
